<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-select(:placeholder='$t("payments.invoice_placeholder")' :danger="$v.form.invoice_id.$invalid && $v.form.invoice_id.$model" :danger-text="$t('validation.required', { attribute: $t('payments.type') })" v-model="form.invoice_id" :label='$t("payments.invoice_display")')
          vm-select-item(:key="index" :value="item.id" :text="item.id" v-for="(item,index) in catalog.invoices")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-currency(autofocus v-model="form.amount" :label='$t("payments.amount")' :placeholder='$t("payments.amount_placeholder")' :danger="$v.form.amount.$invalid && $v.form.amount.$model" :danger-text="!$v.form.amount.maxValue ? $t('validation.max_val', { attribute: $t('revenues.amount') }) : $t('validation.required', { attribute: $t('revenues.amount') })")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-date-picker.full-width(type="date" :label="$t('payments.date')" :placeholder="$t('strings.select_date')" :danger="$v.form.date.$invalid && $v.form.date.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.date') })" v-model="form.date" )
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-select(:placeholder='$t("payments.type_placeholder")' :danger="$v.form.type.$invalid && $v.form.type.$model" :danger-text="$t('validation.required', { attribute: $t('payments.type') })" v-model="form.type" :label='$t("payments.type")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in types")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import { VmCurrency } from 'vm-currency'
const { mapGetters, mapActions } = createNamespacedHelpers('Payments')

export default {
  name: 'ModalPayments',
  components: {
    VmCurrency
  },
  mixins: [ModalMixin1],
  data: () => ({
    types: [
      {
        id: 'transfer',
        name: 'Transferencia'
      },
      {
        id: 'check',
        name: 'Cheque'
      },
      {
        id: 'other',
        name: 'Otro'
      },
      {
        id: 'cash',
        name: 'Efectivo'
      }
    ]
  }),
  validations () {
    return {
      form: {
        invoice_id: {
          required
        },
        amount: {
          required
        },
        date: {
          required
        },
        type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
